module.exports = __webpack_public_path__ + "static/media/5.52dc81e0.jpg";